// extracted by mini-css-extract-plugin
module.exports = {"casinoSearchResult":"search-results_casinoSearchResult__2JILS","sr-search-livecasino":"search-results_sr-search-livecasino__Db8_d"};